export function commaSeperate(numberString?: string | number): string {
    if (numberString == undefined) {
        return "";
    }
    return numberString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
